var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"checkbox-container"},[_c('input',{staticClass:"checkbox-input",attrs:{"type":"checkbox"},domProps:{"checked":_vm.checked},on:{"change":function($event){return _vm.$emit('change', $event.target.checked)}}}),_c('span',{staticClass:"checkbox-box",class:{ checked: _vm.checked }}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }